import getPrototypeOf from "./getPrototypeOf";
import superPropBase from "./superPropBase";
export default function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/get.js
// module id = 404
// module chunks = 0